import { Injectable } from '@angular/core';
import { StateDispatcher, StateOrchestrator } from 'microedge-rxstate/dist';
import { ListToolbarStateAction } from './toolbar-state-action.type';


export class ListToolbarStateDispatcher extends StateDispatcher<ListToolbarStateAction> {
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

export class ListToolbarStateOrchestrator<T> extends StateOrchestrator<T, ListToolbarStateAction> {
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
